import { render, staticRenderFns } from "./ViewPermissionDia.vue?vue&type=template&id=7ac51b0b&scoped=true"
import script from "./ViewPermissionDia.vue?vue&type=script&lang=js"
export * from "./ViewPermissionDia.vue?vue&type=script&lang=js"
import style0 from "./ViewPermissionDia.vue?vue&type=style&index=0&id=7ac51b0b&prod&scoped=true&lang=scss&ref=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ac51b0b",
  null
  
)

export default component.exports